<style src="./CameraMonitor.scss" lang="scss"></style>
<template>
  <section class="camera-monitor">
    <vue-h-zoom
      :image="selectedPhoto.path"
      :image-full="selectedPhoto.path"
      :zoom-level="4"
      :width="800"
      :height="540"
      :zoom-window-size="0.7"
      :zoom-window-x="650"
    >
    </vue-h-zoom>
    <form
      @submit.prevent
      class="form"
      v-shortkey="['esc']"
      @shortkey="submitRemove(selectedPhoto.id)"
    >
      <label>
        <span>Placa do Veículo</span>
        <input
          type="text"
          v-model="form.licencePlate"
          ref="inputLicencePlate"
        />
      </label>
      <label>
        <span>Estacionamento</span>
        <select v-model="form.parking">
          <option
            v-for="(park, parkIdx) in parks"
            :key="parkIdx"
            :value="park.id"
          >
            {{ park.name }}
          </option>
        </select>
      </label>

      <fieldset class="config">
        <label>
          <span>Quantidade de fotos</span>
          <input type="text" v-model="form.countPhotos" />
        </label>
        <label>
          <span>Taxa Atualização(ms)</span>
          <input type="text" v-model="form.refreshRate" />
        </label>
      </fieldset>

      <fieldset>
        <button
          class="buttonaccept"
          @click="submitAcceptEMPRO"
          :disabled="disabled.accept"
        >
          Aceitar
        </button>

        <button
          type="button"
          class="buttonremove"
          @click="submitRemove(selectedPhoto.id)"
          :disabled="disabled.remove"
        >
          Remover
        </button>
      </fieldset>
    </form>

    <section class="photolist">
      <figure
        class="photos"
        :class="{ selected: selectedPhoto.id === photo.id }"
        v-for="(photo, photoIdx) in photos"
        :key="photoIdx"
      >
        <button
          type="button"
          @click.stop="submitRemove(photo.id, photoIdx)"
          :disabled="disabled.remove"
        >
          Remover
        </button>
        <img :src="photo.path" @click="selectPhoto(photo, photoIdx)" />
      </figure>
    </section>
  </section>
</template>

<script>
import { URI_VEHICLE_SCAN } from '@/config/config';
import VueHZoom from 'vue-h-zoom';

let refreshInterval = null;
const secondsToRemoveTempImage = 20; // Time to keep the image on temp list

export default {
  components: {
    VueHZoom,
  },
  data: () => ({
    photos: [],
    removedPhotos: [],
    selectedPhoto: {
      id: null,
      path: '',
      idx: -1,
    },
    form: {
      licencePlate: '',
      parking: '',
      countPhotos: 10,
      refreshRate: 5000, // Interval to list all images from server
      eraseRemovedPhotosInterval: 10000, // Interval to check the temp list and remove item
    },
    disabled: {
      removeButton: false,
      accept: false,
    },
    parks: [],
  }),
  mounted() {
    this.listAllParks();
    this.listAllPhotos();
    refreshInterval = setInterval(
      () => this.listAllPhotos(),
      this.form.refreshRate,
    );
    setInterval(
      () => this.removeTempPhotos(),
      this.form.eraseRemovedPhotosInterval,
    );
  },
  watch: {
    'form.refreshRate'() {
      clearInterval(refreshInterval);
      if (this.form.refreshRate < 2000) {
        return;
      }
      this.form.eraseRemovedPhotosInterval =
        Number(this.form.refreshRate) + 10000;
      refreshInterval = setInterval(
        () => this.listAllPhotos(),
        this.form.refreshRate,
      );
    },
  },
  methods: {
    removeTempPhotos() {
      const now = new Date().getTime();
      const newRemovedPhotos = this.removedPhotos.filter(i => {
        return !(i.removeWhen <= now);
      });
      this.removedPhotos = newRemovedPhotos;
    },
    addDecimalDotOnGeolocation(value) {
      const cleanValue = value.replace('.jpg', '');
      const addSignal = `-${cleanValue}`;
      const addDot =
        addSignal.substring(0, 3) +
        '.' +
        addSignal.substring(3, addSignal.length);
      return addDot;
    },
    formatLicencePlate(value) {
      const upper = value.toUpperCase();
      const dash = upper.substring(0, 3) + '-' + upper.substring(3, 7);
      return dash;
    },
    formatDateBR(value) {
      const options = {
        hour: 'numeric',
        minute: 'numeric',
        second: 'numeric',
      };
      const dt = new Intl.DateTimeFormat('pt-BR').format(new Date(value));
      const tm = new Intl.DateTimeFormat('pt-BR', options).format(
        new Date(value),
      );
      return `${dt} ${tm}`;
    },
    async listAllParks() {
      const parkingListFull = await this.$store.dispatch('PARKING/GetParkList');
      const parks = parkingListFull.map(park => ({
        id: park._id,
        name: park.parkName,
      }));
      this.parks = parks;
    },
    async listAllPhotos() {
      if (this.photos.length === this.form.countPhotos) {
        return;
      }
      const opts = {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      };

      const userLoginInfoResult = await fetch(
        `${URI_VEHICLE_SCAN}list-all-from-folder?countPhotos=${this.form.countPhotos}`,
        opts,
      );
      const photos = await userLoginInfoResult.json();
      const avoidPhotos = this.removedPhotos.map(i => i.id);

      const photoMapped = photos
        .filter(photo => avoidPhotos.indexOf(photo) === -1)
        .map(photo => {
          const [type, dateTimestamp, parking, lat, lng] = photo.split('-');
          const latitude = this.addDecimalDotOnGeolocation(lat);
          const longitude = this.addDecimalDotOnGeolocation(lng);

          return {
            id: photo,
            path: `${URI_VEHICLE_SCAN}ocr/${photo}`,
            dateTime: new Date(Number(dateTimestamp)),
            type,
            parking,
            latitude,
            longitude,
          };
        });
      this.photos = photoMapped;
      if (this.selectedPhoto.id === null && photoMapped.length > 0) {
        this.selectPhoto(photoMapped[0], 0);
      }
    },
    selectPhoto(photoMapped, photoIdx) {
      this.$refs.inputLicencePlate.focus();

      if (!this.photos.length) {
        this.parks = [];
        this.selectedPhoto = {
          id: null,
          path: '',
        };
        return false;
      }
      this.form.parking = photoMapped.parking;
      this.parks = [
        {
          id: photoMapped.parking,
          name: photoMapped.parking,
        },
      ];
      this.selectedPhoto = {
        ...photoMapped,
        idx: photoIdx,
      };
    },
    submitVehicles() {
      this.submitAccept();
      this.submitAcceptEMPRO();
    },
    addTempImage(photoId) {
      const timestampToRemove =
        new Date().getTime() + secondsToRemoveTempImage * 1000;
      this.removedPhotos.push({
        removeWhen: timestampToRemove,
        id: photoId,
      });
    },
    async submitAcceptEMPRO() {
      const hasLicencePlate =
        this.form.licencePlate && this.form.licencePlate.trim().length === 7;
      if (!hasLicencePlate) return;

      this.disabled.accept = true;
      const payload = {
        originalDate: this.selectedPhoto.dateTime,
        data: this.formatDateBR(this.selectedPhoto.dateTime),
        placa: this.formatLicencePlate(this.form.licencePlate),
        latitude: this.selectedPhoto.latitude,
        longitude: this.selectedPhoto.longitude,
        id_setor: this.form.parking,
        fileName: this.selectedPhoto.id,
      };

      // Reset form
      this.addTempImage(this.selectedPhoto.id);
      this.photos.splice(this.selectedPhoto.idx, 1);
      this.form.licencePlate = '';
      this.$refs.inputLicencePlate.focus();
      this.selectPhoto(this.photos[0], 0);

      const client = this.$store.getters['DATA-ACCESS/client'];
      const opts = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          clientid: client._id,
        },
        body: JSON.stringify(payload),
      };
      try {
        await fetch(`${URI_VEHICLE_SCAN}empro/licence-plate`, opts);
        this.form.licencePlate = '';
      } catch (error) {
        console.error(error);
      } finally {
        this.disabled.accept = false;
      }
    },
    async submitAccept() {
      if (
        !(this.form.licencePlate && this.form.licencePlate.trim().length > 5)
      ) {
        return;
      }
      this.disabled.accept = true;
      const payload = {
        licencePlate: this.form.licencePlate.toLowerCase(),
        parkId: this.form.parking,
        fileName: this.selectedPhoto.id,
      };

      const opts = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(payload),
      };
      try {
        await fetch(`${URI_VEHICLE_SCAN}park`, opts);
        this.form.licencePlate = '';
        await this.listAllPhotos();
        this.selectFirstItem();
      } catch (error) {
        console.error(error);
      } finally {
        this.disabled.accept = false;
      }
    },
    async submitRemove(photoId, photoIdx) {
      this.addTempImage(photoId);
      this.photos.splice(photoIdx, 1);
      const URI = `${URI_VEHICLE_SCAN}remove-photo/${photoId}`;

      this.disabled.remove = true;
      const opts = {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      };
      try {
        await fetch(URI, opts);
        await this.listAllPhotos();
        this.selectFirstItem();
      } catch (error) {
        console.error(error);
      } finally {
        this.disabled.remove = false;
      }
    },
    selectFirstItem() {
      if (this.photos.length > 0) {
        const firstPhoto = this.photos[0];
        this.selectedPhoto = firstPhoto;
      } else {
        this.selectedPhoto = {
          id: null,
          path: '',
        };
      }
    },
  },
};
</script>
